module.exports = __webpack_public_path__ + "static/media/employee_level_active.3b738598.svg";